import { render, staticRenderFns } from "./tagbox.vue?vue&type=template&id=2f5af548&scoped=true&"
import script from "./tagbox.vue?vue&type=script&lang=ts&"
export * from "./tagbox.vue?vue&type=script&lang=ts&"
import style0 from "./tagbox.vue?vue&type=style&index=0&id=2f5af548&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5af548",
  null
  
)

export default component.exports